// extracted by mini-css-extract-plugin
export default {"icon":"TableMenuOption_icon__zNgKk","option":"TableMenuOption_option__O1ogZ"};